<template>
  <div :class="rootClass">
    <div v-if="isShowErrNoti" class="font-medium-4 notiPopup">
      <div class="d-flex flex-column">
        <img
            src="@/assets/images/icons/x-circle.svg"
            style="width: 100px;height: 100px;margin-left: 40%;margin-bottom: 5%"
        />
        <p
            style="font-size: 21px;font-weight: 700;line-height: 36px;text-align: center;"
        >
          {{ notiContent }}
        </p>
        <button
            class="buttonOK mt-2"
            style="margin-left: 30%"
            @click="isShowErrNoti = false"
        >
          OK
        </button>
      </div>
    </div>
    <div v-if="isShowConfirmCancelPack" class="font-medium-4 confirmPopup">
      <div class="d-flex flex-column">
        <p class="mb-2" style="color: black; font-weight: bold; font-size: 28px; text-align: center">Thông báo</p>
        <p style="font-size: 21px;font-weight: 700;line-height: 36px;text-align: center;">Bạn chắc chắn muốn hủy gói
          <span class="text-primary">{{ currentCancelPack }}</span> gói không?</p>
        <div class="d-flex justify-content-around mt-5">
          <button class="buttonOK" @click="()=>{cancelPack()}">Đồng ý</button>
          <button class="buttonOK" @click="isShowConfirmCancelPack=false">Hủy</button>
        </div>
      </div>
    </div>
    <div v-if="isShowImgPopup" class="font-medium-4 imgPopup">
      <div class="d-flex flex-column">
        <div style="width: 75vw;height: 70vh; overflow: scroll">
          <img :src="'data:image/png;base64,' + currentImg"/>
        </div>
        <a
            class="closeImgPopupButton "
            href="#"
            @click="isShowImgPopup = false"
        ></a>
      </div>
    </div>
    <div
        v-if="isListShowPackage"
        class="font-medium-4 notiPopup"
        style="left: 10vw;width: 80vw"
    >
      <table class="searchTable">
        <tr>
          <th>Tên gói</th>
          <th>Data gói chính</th>
          <th>Data gói KM</th>
          <th>Phút gọi nội mạng</th>
          <th>Phút gọi ngoại mạng</th>
          <th>Tin nhắn nội mạng</th>
          <th>Tin nhắn ngoại mạng</th>
          <th>Thời gian bắt đầu</th>
          <th>Thời gian kết thúc</th>
          <th>Thao tác</th>
        </tr>
        <tr
            v-for="i in listCurrentPackage"
            :key="i.packageName"
            class="font-medium-2"
        >
          <td style="width: 12%">{{ i.packageName }}</td>
          <td style="width: 8%">{{ i.dataMain }}</td>
          <td style="width: 8%">{{ i.dataKm }}</td>
          <td style="width: 8%">{{ i.voiceOnNet }}</td>
          <td style="width: 8%">{{ i.voiceOutNet }}</td>
          <td style="width: 7%">{{ i.smsOnNet }}</td>
          <td style="width: 7%">{{ i.smsOutNet }}</td>
          <td style="width: 14%">{{ i.timeStart }}</td>
          <td style="width: 14%">{{ i.timeEnd }}</td>
          <td style="width: 14%">
            <button class="btn btn-primary" @click="handleCancelPack(i.packageName)">Hủy gói</button>
          </td>
        </tr>
      </table>
      <div class="d-flex justify-content-center">
        <button
            class="buttonOK mt-2"
            style=""
            @click="isListShowPackage = false"
        >
          OK
        </button>
      </div>
    </div>
    <b-row class="mb-2">
      <b-col lg="5" md="12">
        <b-row align-v="center" class="mb-2 ">
          <p class="col-3 p-0">Số thuê bao</p>
          <b-form-input
              class="col-1 --input"
              disabled
              value="+84"
          ></b-form-input>
          <div :class="visibleReset4G?'col-6':'col-8 pr-0'">
            <b-form-input
                class="--input"
                :value="searchPhone.slice(1, 11)"
                disabled
            ></b-form-input>
          </div>
          <button class="col-2 btn btn-primary" style="padding: 0.438rem 0.5rem" @click="reset4G" v-if="visibleReset4G">
            Reset 4G
          </button>
        </b-row>
        <b-row align-v="center" class="mb-1 justify-content-between">
          <p>Thống kê lưu lượng sử dụng</p>
          <button class="btn btn-primary btn-sm" @click="renewPackage">Gia hạn gói cước</button>
        </b-row>
        <b-row align-v="center" class="mb-2 border rounded" style="border-color: #d8d6de !important;">
          <table class="w-100 table dataTable" v-if="psc">
            <thead>
            <tr class="border-bottom">
              <td class="font-weight-bolder">{{ psc.type }}</td>
              <td class="font-weight-bolder" v-for="i in psc.detail">{{ i.MO }}</td>
            </tr>
            </thead>
            <tbody>
            <tr class="border-bottom">
              <td class="font-weight-bolder">Tổng lưu lượng</td>
              <td v-for="i in psc.detail" class="text-right">{{ i.DU }}</td>
            </tr>
            <tr>
              <td class="font-weight-bolder">Trung bình ngày</td>
              <td v-for="i in psc.detail" class="text-right">{{ i.AG }}</td>
            </tr>
            </tbody>
          </table>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Định dạng số</p>
          <b-form-input
              v-b-tooltip.hover
              :class="'--input col-3'"
              :title="TTTB.NUM_TYPE"
              :value="TTTB.NUM_TYPE"
              disabled
          ></b-form-input>
          <p class="col-3">Không chuyển mạng trước</p>
          <b-form-input
              :class="'--input col-3'"
              :value="commitSatus.commitNoMnp"
              disabled
          ></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Loại thuê bao</p>
          <b-form-input
              :class="'--input col-9'"
              disabled
              value="Di động trả trước"
          ></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Ngày kích hoạt</p>
          <b-form-input
              :class="'--input col-3'"
              :value="subscriberStatus.activeDate"
              disabled
          ></b-form-input>
          <p class="col-3"
          >Hạn sử dụng</p
          >
          <b-form-input
              :class="'--input col-3'"
              :value="balance.coreBalanceExp"
              disabled
          ></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Sim cam kết</p>
          <b-form-input
              :class="'--input col-3'"
              :value="commitSatus.packageName ? 'Sim cam kết' : ''"
              disabled
          ></b-form-input>
          <p
              :class="'col-3'"
          >
            Số tháng cam kết</p
          >
          <b-form-input
              :class=" 'col-3 --input'"
              :value="commitSatus.totalMonth"
              disabled
          ></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Gói cước cam kết</p>
          <b-form-input
              :class="'--input '+ (isVisibleCommitBtn? 'col-2' : 'col-3 ')"
              :value="commitSatus.packageName"
              disabled
          ></b-form-input>
          <p :class="'col-3'"
          >Thời gian cam kết còn lại</p
          >
          <div :class="(isVisibleCommitBtn?'col-2 pl-0 ':'col-3 p-0' )">
            <b-form-input
                :class="' --input'"
                :value="commitSatus.remainMonth"
                disabled
            ></b-form-input>
          </div>
          <button
              v-if="isVisibleCommitBtn"
              class="btn btn-primary btn-sm col-2"
              @click="openCommit"
          >
            Mở khóa
          </button>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0 pr-1">Chu kỳ cam kết gần nhất </p>
          <b-form-input
              :class="'--input col-3'"
              :value="commitSatus.dateStart?moment(commitSatus.dateStart).format('hh:mm DD/MM/YYYY') : ''"
              disabled
          ></b-form-input>
          <p
              :class="'col-3'"
          >
            Đến ngày</p
          >
          <b-form-input
              :class=" 'col-3 --input'"
              :value="commitSatus.dateEnd?moment(commitSatus.dateEnd).format('hh:mm DD/MM/YYYY') : ''"
              disabled
          ></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Họ tên KH</p>
          <b-form-input
              :class="'--input col-9'"
              :value="TTTB.FULLNAME"
              style="line-height: 3"
              disabled
          ></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Đối tượng sử dụng</p>
          <b-form-input
              :class="'col-3 --input'"
              disabled
              value="Bản thân"
          ></b-form-input>
          <p :class=" 'col-3'">Ngày sinh</p>
          <b-form-input
              :class="'col-3 --input'"
              :value="TTTB.BIRTHDAY"
              disabled
          ></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Loại giấy tờ</p>
          <b-form-input
              :class=" 'col-3 --input'"
              :value="TTTB.IDNUMBERTYPE"
              disabled
          ></b-form-input>
          <p :class=" 'col-3'">Ngày cấp</p>
          <b-form-input
              :class="'col-3 --input'"
              :value="TTTB.PLACEDATE"
              disabled
          ></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Số giấy tờ</p>
          <b-form-input
              :class="'col-3 --input'"
              :value="TTTB.IDNUMBER"
              disabled
          ></b-form-input>
          <p :class="  'col-3 '">Nơi cấp</p>
          <b-form-input
              :class=" 'col-3 --input'"
              :value="TTTB.PLACEOFISSUE"
              disabled
          ></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Địa điểm giao dịch</p>
          <b-form-input :class="'--input col-9'" disabled value=""></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Địa chỉ công ty</p>
          <b-form-input
              v-b-tooltip.hover
              :class="'--input col-9'"
              disabled
              title="B018, Tháp The Manor, Mễ Trì, Q. Nam Từ Liêm, Hà Nội"
              value="B018, Tháp The Manor, Mễ Trì, Q. Nam Từ Liêm, Hà Nội"
          ></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Địa chỉ thường trú</p>
          <b-form-input
              v-b-tooltip.hover
              :class="'--input col-9'"
              :title="TTTB.ADDRESS"
              :value="TTTB.ADDRESS"
              disabled
          ></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Ghi chú</p>
          <b-form-input
              :class="'--input col-9'"
              :value="dkttHistoryNote"
              disabled
          ></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0"> Trạng thái thuê bao (IC/OC)</p>
          <b-form-checkbox
              id="checkBoxOc"
              v-model="subscriberStatus.oc"
              disabled
              style="margin-right: 17px;"
              value="A"
          >
            <p class="black__checkbox">Gọi đi</p>
          </b-form-checkbox>
          <b-form-checkbox v-model="subscriberStatus.ic" disabled value="A">
            <p class="black__checkbox">Gọi đến</p></b-form-checkbox
          >
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p
              :class="rootClass + '__approval-status-p col-3 p-0'"
          >Trạng thái phê duyệt</p
          >
          <b-form-input
              :class="'--input col-9'"
              :value="approveStatus.DEST"
              disabled
          ></b-form-input>
        </b-row>
        <b-row align-v="center">
          <p class="col-3 p-0">Ghi chú lỗi</p>
          <b-form-input
              v-b-tooltip.hover
              :class="'--input col-9'"
              :title="approveStatus.GHICHU"
              :value="approveStatus.GHICHU"
              disabled
          ></b-form-input>
        </b-row>
      </b-col>
      <b-col lg="5" md="12" style="padding-left: 2.5rem">
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Serial sim (MSIN)</p>
          <b-form-input
              :class="'--input col-8'"
              :value="subscriberStatus.msin"
              disabled
          ></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Loại sim</p>
          <b-form-input
              :class="'--input col-8'"
              :value="simType ? 'eSIM' : 'Sim vật lý'"
              disabled
          ></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Thiết bị</p>
          <b-form-input
              :class="'--input col-8'"
              :value="subscriberStatus.device"
              disabled
          ></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Loại khách hàng</p>
          <b-form-input
              :class="'--input col-8'"
              :value="TTTB.CUSTOMERTYPE"
              disabled
          ></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Mã khách hàng</p>
          <b-form-input
              :class="'--input col-8'"
              disabled
              value=""
          ></b-form-input>
        </b-row>

        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Số PIN 1</p>
          <b-form-input
              :class="'--input col-3'"
              :value="pinPuk.PIN"
              disabled
          ></b-form-input>
          <p
              class="text-left col-2"
          >Số PUK 1</p
          >
          <b-form-input
              :class="'--input col-3'"
              :value="pinPuk.PUK"
              disabled
          ></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Số PIN 2</p>
          <b-form-input
              :class="'--input col-3'"
              :value="pinPuk.PIN2"
              disabled
          ></b-form-input>
          <p
              class="text-left col-2"
          >Số PUK 2</p
          >
          <b-form-input
              :class="'--input col-3'"
              :value="pinPuk.PUK2"
              disabled
          ></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Giới tính</p>
          <b-form-input
              :class="'--input col-3'"
              :value="TTTB.GENDER"
              disabled
          ></b-form-input>
          <p
              class="text-left col-2"
          >Quốc tịch</p
          >
          <b-form-input
              :class="'--input col-3'"
              :value="TTTB.NATIONALITYID"
              disabled
          ></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Số Visa</p>
          <b-form-input
              :class="'--input col-3'"
              disabled
              value=""
          ></b-form-input>
          <p
              class="text-left col-2"
          >Ngày hết hạn</p
          >
          <b-form-input
              :class="'--input col-3'"
              disabled
              value=""
          ></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Email KH</p>
          <b-form-input
              :class="'--input col-8'"
              disabled
              value=""
          ></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Nghề nghiệp</p>
          <b-form-input
              :class="'--input col-8'"
              disabled
              value=""
          ></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Ngày đăng ký</p>
          <b-form-input
              :class="'--input col-3'"
              :value="TTTB.REGISTERDATE"
              disabled
          ></b-form-input>
          <p
              class="text-left col-3"
          >Kênh tác động gần nhất</p
          >
          <b-form-input
              :class="'--input col-2'"
              :value="KĐK.methodName"
              disabled
          ></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Hạng hội viên</p>
          <b-form-input
              :class="'--input col-3'"
              :value="phoneRank.rankName"
              disabled
          ></b-form-input>
          <p
              class="text-left col-3"
          >Điểm hiện tại</p
          >
          <b-form-input
              :class="'--input col-2'"
              :value="phoneRank.currentPoint"
              disabled
          ></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Tài khoản chính</p>
          <b-form-input
              :class="'--input col-8'"
              :value="
              new Intl.NumberFormat('vi-VN', {
                style: 'currency',
                currency: 'VND'
              }).format(balance.coreBalance)
            "
              disabled
          ></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Tài khoản KM 1</p>
          <b-form-input
              :class="'--input col-8'"
              :value="balance.tkkm"
              disabled
          ></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Tài khoản KM 2</p>
          <b-form-input
              :class="'--input col-8'"
              :value="balance.tkkm2"
              disabled
          ></b-form-input>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <p class="col-3 p-0">Gói cước đang dùng</p>
          <p
              :class="
              listCurrentPackage.length > 0
                ? 'packageText__Active'
                : 'packageText__InActive'
            "
              variant="danger"
              @click="openListPackagePopUp"
          >
            {{ textPackage }}
          </p>
        </b-row>

      </b-col>
      <b-col lg="2" md="12">
        <table :class="rootClass + '__service-table'" class="data">
          <tr style="height: 3rem; color: white">
            <template v-for="(h, i) in fields">
              <th
                  :key="h.key"
                  :class="{
                  '--first-th': i === 0,
                  '--last-th': i === fields.length - 1
                }"
              >
                {{ h.label }}
              </th>
            </template>
          </tr>
          <template v-for="r in currentService">
            <tr
                :key="r.MA_DV"
                style="height: 3rem; border-top: 0.629766px solid #efefef;font-size: 14px"
            >
              <td>{{ r.MA_DV }}</td>
              <td style="text-align: left; padding-left: 1rem">
                {{ r.TEN_DV }}
              </td>
            </tr>
          </template>
        </table>
      </b-col>
    </b-row>
    <b-row class="mb-1"></b-row>
    <b-row>
      <b-button
          :class="rootClass + '__add-complain-btn'"
          class="mr-1"
          variant="outline-primary"
      >Thêm mới khiếu nại
      </b-button>
      <b-button
          :class="rootClass + '__complain-history-btn'"
          class="mr-1"
          variant="outline-primary"
      >Lịch sử khiếu nại
      </b-button>
      <b-button
          v-if="policy_confirm_pdf"
          :class="rootClass + '__complain-history-btn'"
          class="mr-1"
          variant="outline-primary"
          @click="handleWatchPdf('policy_confirm_pdf')"
      >Xem phiếu BVDLCN
      </b-button>
      <b-button
          v-if="bbck"
          :class="rootClass + '__complain-history-btn'"
          class="mr-1"
          variant="outline-primary"
          @click="handleWatchPdf('bbck')"
      >Xem phiếu cam kết
      </b-button>
    </b-row>
    <b-row>
      <b-col v-if="imageCode != undefined" class="text-center">
        <img
            :src="'data:image/png;base64,' + imageCode.img1"
            alt="Rounded image"
            class="--border-dashed"
            rounded
            style="object-fit: contain"
            v-bind="imgProps"
            @click="changeCurrentImg(imageCode.img1)"
        />
        <p style="width: unset">Ảnh mặt trước giấy tờ của TB cá nhân</p>
      </b-col>
      <b-col v-if="imageCode != undefined" class="text-center">
        <img
            :src="'data:image/png;base64,' + imageCode.img2"
            alt="Rounded image"
            class="--border-dashed"
            rounded
            style="object-fit: contain"
            v-bind="imgProps"
            @click="changeCurrentImg(imageCode.img2)"
        />
        <p style="width: unset">Ảnh mặt sau giấy tờ của TB cá nhân</p>
      </b-col>

      <b-col v-if="imageCode != undefined" class="text-center">
        <img
            :src="'data:image/png;base64,' + imageCode.img3"
            alt="Rounded image"
            class="--border-dashed"
            rounded
            style="object-fit: contain"
            v-bind="imgProps"
            @click="changeCurrentImg(imageCode.img3)"
        />
        <p style="width: unset"
        >Ảnh người đến đăng ký thông tin TB cá nhân</p
        >
      </b-col>
      <b-col v-if="imageCode != undefined" class="text-center">
        <img
            :src="'data:image/png;base64,' + imageCode.img4"
            alt="Rounded image"
            class="--border-dashed"
            rounded
            style="object-fit: contain"
            v-bind="imgProps"
            @click="changeCurrentImg(imageCode.img4)"
        />
        <p style="width: unset">Ảnh phiếu đăng ký/Hợp đồng DKTT</p>
      </b-col>
    </b-row>
    <b-modal
        id="modal-pdf"
        size="lg"
        title="Chính sách bảo vệ dữ liệu cá nhân"
        hide-footer
    >
      <template>
        <div class="h-100 w-100" v-if="typePdf==='policy_confirm_pdf'">
          <iframe
              :src="prefixImgLink() + policy_confirm_pdf"
              class="h-100 w-100"/>
        </div>
        <div class="h-100 w-100" style="height: 80vh"  v-if="typePdf==='bbck'">
        <iframe
            :src="bbck"
            alt="bbck"
            class="h-100 w-100"

        />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BImg,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTable,
  BTooltip
} from "bootstrap-vue";
import vSelect from "vue-select";
import DropMenu from "./DropMenu.vue";
import axios from "axios";
import useJwt from "@/auth/jwt/useJwt";
import {$ctx} from "@themeConfig";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";
import {prefixImgLink} from "@/store/helper";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BModal,
    BFormGroup,
    BFormCheckbox,
    BImg,
    DropMenu
  },
  computed: {
    moment() {
      return moment
    },
    isVisibleCommitBtn() {
      return this.commitSatus.commitType === 'PSC' && this.commitSatus.isUnlockable
    }
  },
  data() {
    return {
      typePdf:"",
      visibleReset4G: false,
      rootClass: "subscriber-information",
      fields: [
        {key: "serviceCode", label: "Mã dịch vụ"},
        {key: "serviceName", label: "Tên dịch vụ"}
      ],
      imgProps: {
        blank: true,
        width: 500,
        height: 300,
        class: "m-1 bg-transparent"
      },
      balance: {},
      currentPackage: {},
      listCurrentPackage: [],
      TTTB: {},
      pinPuk: {},
      msisdn: {},
      subscriberStatus: {},
      approveStatus: {},
      phoneRank: {},
      isShowErrNoti: false,
      isShowConfirmCancelPack: false,
      currentCancelPack: "",
      notiContent: "",
      KĐK: {},
      currentService: [],
      isListShowPackage: false,
      textPackage: "",
      imageCode: {},
      policy_confirm_pdf: "",
      bbck: "",
      isShowImgPopup: false,
      currentImg: "",
      commitSatus: {},
      simType: "",
      dkttHistoryNote: "",
      psc: null
    };
  },
  props: {
    searchPhone: String
  },
  watch: {
    searchPhone: function (i, v) {
      this.showLoading("block");
      // this.getKitInfo();
      this.getCurrentPackage();
      this.getSubscriberStatus();
      this.getSubscriberBalance();
      this.getMsisdn();
      this.getApproveStatus();
      this.getPhoneRank();
      this.getRegisterMethod();
      this.getCurrentService();
      this.getImageCode();
      this.getCheckCommit();
      this.getTTTB();
      this.getDTKKHistory();
    }
  },
  mounted() {
    this.showLoading("block");
    // this.getKitInfo();
    this.getTTTB();
    this.getCurrentPackage();
    this.getSubscriberStatus();
    this.getSubscriberBalance();
    this.getMsisdn();
    this.getApproveStatus();
    this.getPhoneRank();
    this.getRegisterMethod();
    this.getCurrentService();
    this.getImageCode();
    this.getCheckCommit();
    this.getDTKKHistory();
    this.getVisibleReset4G();
    this.checkData()

    // this.getPsc();
  },
  methods: {
    prefixImgLink() {
      return prefixImgLink
    },
    handleWatchPdf(pdf){
      this.typePdf=pdf
      this.$bvModal.show('modal-pdf')
    },
    renewPackage() {
      useJwt.get("extend/" + this.searchPhone).then(res => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: res.data.message ? res.data.message : "Gia hạn thành công",
            icon: "AlertTriangleIcon",
            variant: "success"
          }
        });
      }).catch(err => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: err.response.data.message ? err.response.data.message : "Gia hạn thất bại",
            icon: "AlertTriangleIcon",
            variant: "error"
          }
        });
      })
    },
    reset4G() {
      useJwt.get("reset4g/" + this.searchPhone).then(res => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: res.data.message,
            icon: "AlertTriangleIcon",
            variant: "success"
          }
        });
      }).catch(err => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: err.response.data.message,
            icon: "AlertTriangleIcon",
            variant: "error"
          }
        });
      })
    },
    getVisibleReset4G() {
      useJwt.get("check_reset4g/" + this.searchPhone).then(res => {
        this.visibleReset4G = res.data.result.visible;
        // console.log("visibleReset4G",res.data.result.visible)
        // this.$toast({
        //   component: ToastificationContent,
        //   props: {
        //     title: res.data.message,
        //     icon: "AlertTriangleIcon",
        //     variant: "success"
        //   }
        // });
      }).catch(err => {
        // this.$toast({
        //   component: ToastificationContent,
        //   props: {
        //     title: err.response.data.message,
        //     icon: "AlertTriangleIcon",
        //     variant: "error"
        //   }
        // });
      })
    },
    showLoading(options) {
      document.getElementById("loading-bg").style.display = options;
    },
    getDTKKHistory() {
      useJwt
          .get("get-dktt-note/" + this.searchPhone)
          .then(response => {
            this.dkttHistoryNote = response.data.result;
            // console.log("getDTKKHistory", response.data.result);
          })
          .catch(error => {
            console.log(error);
          });
    },
    getMsisdn() {
      useJwt
          .get("Msisdn_FromMsin/" + this.searchPhone)
          .then(response => {
            this.msisdn = response.data.result.result;
            // console.log("getMsisdn", response.data.result);
          })
          .catch(error => {
            console.log(error);
          });
    },
    getCurrentPackage() {
      useJwt
          .get("get_current_package/" + this.searchPhone)
          .then(response => {
            if (response.data.result.result.length > 0) {
              this.textPackage = "Xem tại đây";
              response.data.result.result.forEach(e => {
                e.dataMain = (e.dataMain / 1048576).toFixed(2) + " MB";
                e.dataKm = (e.dataKm / 1048576).toFixed(2) + " MB";
                this.listCurrentPackage.push(e);
              });
              // console.log("getCurrentPackage", this.listCurrentPackage);
            } else {
              this.textPackage = "Không có gói cước nào";
            }
          })
          .catch(error => {
            console.log(error);
          });
    },

    openCommit() {
      this.showLoading("block");
      useJwt
          .get(
              "itel-open-commit/" +
              this.commitSatus.msisdn +
              "/" +
              this.commitSatus.acctId
          )
          .then(res => {
            this.showLoading("none");
            if (res.data.code === 100) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: res.data.message
                      ? res.data.message
                      : "Mở khóa thành công",
                  icon: "AlertTriangleIcon",
                  variant: "success"
                }
              });
              this.getCheckCommit();
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: res.data.message ? res.data.message : "Mở khóa thất bại",
                  icon: "AlertTriangleIcon",
                  variant: "error"
                }
              });
            }
          })
          .catch(err => {
            this.showLoading("none");
            this.$toast({
              component: ToastificationContent,
              props: {
                title: err.response.data.message
                    ? err.response.data.message
                    : "Mở khóa thất bại",
                icon: "AlertTriangleIcon",
                variant: "error"
              }
            });
          });
    },

    getSubscriberBalance() {
      useJwt
          .get("get_subscriber_balance/" + this.searchPhone)
          .then(response => {
            this.balance = response.data.result.result;
            this.balance.coreBalanceExp = this.balance.coreBalanceExp.slice(
                0,
                10
            );
            this.balance.activeDate = this.balance.activeDate.slice(0, 10);
            // console.log("getSubscriberBalance", response.data);
          })
          .catch(error => {
            console.log(error);
          });
    },
    getSubscriberStatus() {
      try {
        useJwt
            .get("get_subscriber_status/" + this.searchPhone)
            .then(response => {
              this.subscriberStatus = response.data.result.result;
              // console.log("getSubscriberStatus", response.data);
              this.subscriberStatus = {
                ...this.subscriberStatus,
                device: response.data.result.device
              }

              if (this.subscriberStatus.msin === null) {
                this.isShowErrNoti = true;
                if (
                    this.notiContent === "" ||
                    this.notiContent === "Thuê bao không có thông tin"
                ) {
                  this.notiContent = "Không lấy được thông tin dữ liệu";
                }
              } else {
                this.getPinPuk(this.subscriberStatus.msin);
                this.getFullSimSerial();
              }
            })
            .catch(error => {
              console.log(error);
            });
      } catch (e) {
        console.log(e);
      }
    },
    async getSimType(fullSerialSim) {
      await axios
          .post($ctx.API_URL + "getESIMStatusKH", [fullSerialSim], {
            headers: {
              Token: localStorage.getItem("accessToken"),
              accept: "application/json"
            }
          })
          .then(res => {
            this.simType = res.data.result;
            // console.log("sim type", res)
          })
          .catch(err => {
            console.log(err);
          });
    },
    getFullSimSerial() {
      useJwt
          .get("query-sim-serial/" + this.subscriberStatus.msin)
          .then(response => {
            // console.log("serial sim", response.data.result.result)
            this.getSimType(response.data.result.result);
          })
          .catch(error => {
            console.log(error);
          });
    },
    getPinPuk(msin) {
      useJwt
          .get("get_pin_puk_from/" + msin)
          .then(response => {
            this.pinPuk = response.data.result.result[0];
            // console.log("PinPuk", this.pinPuk)
          })
          .catch(error => {
            console.log(error);
          });
    },
    getKitInfo() {
      useJwt
          .get("get-kit-info/" + this.searchPhone)
          .then(response => {
            // console.log("kit", response.data);
          })
          .catch(error => {
            console.log(error);
          });
    },
    getTTTB() {
      useJwt
          .get("search_pps_info/" + this.searchPhone)
          .then(response => {
            this.showLoading("none")
            this.TTTB = response.data.result;
            // this.$router.push("/subscriber/corporate-subscribe-info")
            // console.log("TTTB", this.TTTB)
          })
          .catch(error => {
            this.showLoading("none")
            this.TTTB = {};
            this.isShowErrNoti = true;
            if (this.notiContent === "") {
              this.notiContent = "Thuê bao không có thông tin";
            }
          });
    },
    getApproveStatus() {
      useJwt
          .get("check_approve_status/" + this.searchPhone)
          .then(response => {
            this.approveStatus = response.data.result.result;
            // console.log("kit", response.data);
          })
          .catch(error => {
            console.log(error);
          });
    },
    getPhoneRank() {
      useJwt
          .get("clients/phone/?phone=" + this.searchPhone)
          .then(response => {
            if (response.data.result.data === null) {
              this.phoneRank.rankName = "";
            } else {
              this.phoneRank = response.data.result.data;
            }
            // console.log("rank", response.data);
          })
          .catch(error => {
            console.log(error);
          });
    },
    getRegisterMethod() {
      useJwt
          .get("get-register-method/" + this.searchPhone)
          .then(response => {
            this.KĐK = response.data.result.result;
            // console.log("getRegisterMethod", response.data);
          })
          .catch(error => {
            console.log(error);
          });
    },
    getCurrentService() {
      useJwt
          .get("get-current-service/" + this.searchPhone)
          .then(response => {
            this.currentService = response.data.result.result;
            this.currentService.forEach(e => {
              switch (e.MA_DV.trim()) {
                case "ST4G":
                  e.TEN_DV = "ST4G";
                  break;
                case "IDD":
                  e.TEN_DV = "Goi quoc te";
                  break;
                case "GPRS":
                  e.TEN_DV = "GPRS";
                  break;
                case "SMO":
                  e.TEN_DV = "Gui tin nhan";
                  break;
                case "SMT":
                  e.TEN_DV = "Nhan tin nhan";
                  break;
                case "USSD":
                  e.TEN_DV = "USSD";
                  break;
                case "OCSI":
                  e.TEN_DV = "OCSI";
                  break;
                case "ST3G":
                  e.TEN_DV = "ST3G";
                  break;
                case "UMB":
                  e.TEN_DV = "Info 360";
                  break;
                case "OC":
                  e.TEN_DV = "OC";
                  break;
                case "MPTY":
                  e.TEN_DV = "MPTY";
                  break;
                case "CW":
                  e.TEN_DV = "Call waitting";
                  break;
                case "CLIP":
                  e.TEN_DV = "Clip";
                  break;
                case "CH":
                  e.TEN_DV = "Call hold";
                  break;
                case "CBR":
                  e.TEN_DV = "Chan cuoc goi";
                  break;
                case "CF":
                  e.TEN_DV = "CF (Call forwarding)";
                  break;
                case "IR":
                  e.TEN_DV = "International Roaming";
                  break;
                case "NR":
                  e.TEN_DV = "National Roaming";
                  break;
                case "CLIR":
                  e.TEN_DV = "Khong hien so chu goi";
                  break;
                case "DATA":
                  e.TEN_DV = "DATA";
                  break;
                case "FAX":
                  e.TEN_DV = "FAX";
                  break;
                case "MCA":
                  e.TEN_DV = "Misscall Alert";
                  break;
                case "CSM":
                  e.TEN_DV = "Content Short Message (CCG)";
                  break;
                case "IRS":
                  e.TEN_DV = "VinaphoneS";
                  break;
                case "VLTE":
                  e.TEN_DV = "VLTE";
                  break;
                case "MSIM":
                  e.TEN_DV = "MSIM";
                  break;
                case "VOWI":
                  e.TEN_DV = "VOWI";
                  break;
              }
            });
            // console.log("getCurrentService", this.currentService);
          })
          .catch(error => {
            console.log(error);
          });
    },
    openListPackagePopUp() {
      if (this.listCurrentPackage.length <= 0) {

      } else {
        this.isListShowPackage = true;
      }
    },
    getImageCode() {
      useJwt
          .get("get-image-code/" + this.searchPhone)
          .then(response => {
            this.imageCode = response.data.result.result.map;
            this.policy_confirm_pdf = response.data.result.policy_confirm_pdf;
            this.bbck = response.data.result.mnp_commit_image;
            // console.log("imgCode", this.imageCode);
          })
          .catch(error => {
            this.imageCode = {
              img1: "",
              img2: "",
              img3: "",
              img4: ""
            };
            console.log(error);
          });
    },
    handleCancelPack(packCode) {
      this.isShowConfirmCancelPack = true
      this.currentCancelPack = packCode
    },
    cancelPack() {
      this.showLoading("block");
      useJwt
          .get("cancel-package/" + this.searchPhone + "/" + this.currentCancelPack)
          .then(response => {
            if (response && response.data && response.data.code === 200) {
              this.showLoading("none")
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: response.data.message ? response.data.message : "Hủy gói thành công",
                  icon: "CheckSquareIcon",
                  variant: "success"
                }
              });

            }
          })
          .catch(error => {
            this.showLoading("none")
            this.$toast({
              component: ToastificationContent,
              props: {
                title: error.response.data.message ? error.response.data.message : "Hủy gói thất bại",
                icon: "AlertTriangleIcon",
                variant: "error"
              }
            });
            console.log(error);
          });
    },
    changeCurrentImg(imgCode) {
      this.isShowImgPopup = true;
      this.currentImg = imgCode;
    },
    getCheckCommit() {
      useJwt
          .get("itel-check-commit/" + this.searchPhone)
          .then(response => {
            this.commitSatus = response.data.result.result;
            // console.log("commit", this.commitSatus)
          })
          .catch(error => {
            this.TTTB = {};
            this.isShowErrNoti = true;
            if (this.notiContent === "") {
              this.notiContent = "Thuê bao không có thông tin";
            }
          });
    },
    // getPsc() {
    //   useJwt
    //       .get("check_psc/" + this.searchPhone)
    //       .then(response => {
    //         this.psc = response.data.result;
    //         console.log("psc", response.data.result)
    //       })
    //       .catch(error => {
    //       });
    // },
    checkData() {
      useJwt
          .get("check_data/" + this.searchPhone)
          .then(response => {
            this.psc = response.data.result;
            console.log("psc", response.data.result)
          })
          .catch(error => {
          });
    },
  }
};
</script>

<style lang="scss" scoped>
.dataTable {
  font-size: 14px;
  border-style: hidden;

  td {
    padding: 0.72rem;
    border-top: none;
  }
}

.gap-1 {
  gap: 0.5rem;
}

.--border-dashed {
  border-style: dashed;
}

.--input {
  color: black;
  font-size: 14px;
  background: #fcfcfc;
  height: 30px;
  //width: 68%;
  padding: 0.438rem 0.5rem;
}

p {
  color: black;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 500;
}

.black__checkbox {
  color: black;
  width: 100%;
}

//.errMsg {
//  padding: 1%;
//  height: 300px;
//  width: 445px;
//  position: fixed;
//  background-color: white;
//  z-index: 10;
//  top: 30%;
//  left: 35%;
//  border-radius: 13.24px;
//  box-shadow: 5px 10px 18px #888888;
//}

.notiPopup {
  padding: 1%;
  min-height: 300px;
  min-width: 445px;
  position: fixed;
  background-color: white;
  z-index: 10;
  top: 25%;
  left: 35%;
  border-radius: 13.24px;
  box-shadow: 5px 10px 18px #888888;
}

.confirmPopup {
  padding: 1%;
  min-height: auto;
  min-width: 445px;
  position: fixed;
  background-color: white;
  z-index: 100;
  top: 25%;
  left: 35%;
  border-radius: 13.24px;
  box-shadow: 5px 10px 18px #888888;
}

.imgPopup {
  padding: 1%;
  min-height: 80vh;
  min-width: 80vw;
  position: fixed;
  background-color: white;
  z-index: 11;
  top: 12%;
  left: 10vw;
  border-radius: 13.24px;
  box-shadow: 5px 10px 18px #888888;
}

.closeImgPopupButton {
  position: absolute;
  border: 2px solid #ed1f24;
  border-radius: 50%;
  right: 5%;
  width: 32px;
  height: 32px;
  background-color: #ed1f24;
}

.closeImgPopupButton:before,
.closeImgPopupButton:after {
  position: absolute;
  left: 13px;
  top: 2px;
  content: " ";
  height: 25px;
  width: 2px;
  background-color: white;
}

.closeImgPopupButton:before {
  transform: rotate(45deg);
}

.closeImgPopupButton:after {
  transform: rotate(-45deg);
}

td {
  color: black;
  font-weight: 500;
  border-right: 0.299185px solid rgba(184, 184, 184, 0.5);
}

.searchTable {
  border-radius: 16px;
  width: 100%;
  text-align: center;

  tr th,
  tr td {
    padding: 1%;
    border: 0.299185px solid rgba(184, 184, 184, 0.5);
    //border-left: 0.299185px solid rgba(184, 184, 184, 0.5);
  }

  tr td {
    color: black;
  }

  th {
    background-color: #ed1f24;
    color: white;
  }
}

.subscriber-information {
  font-size: 16px;
  font-family: "Times New Roman";

  &__card {
    border-radius: 2rem;
  }

  &__national-code-input {
    width: 8%;
    margin-right: 1%;
  }

  &__phone-input {
    width: 46%;
    margin-right: 2%;
  }

  &__sim-commit-label {
    width: 28%;
  }

  &__sim-commit-input {
    width: 20%;
    margin-right: 6px;
  }

  &__sim-commit-month-input {
    width: 10%;
  }

  &__pack-commit-input {
    width: 14%;
  }

  &__pack-commit-month-input {
    width: 10%;
  }

  &__time-commit-remain-label {
    width: 26%;
    margin-left: 17px;
  }

  &__self-input {
    width: 24%;
  }

  &__date-of-birth-input {
    width: 24%;
  }

  &__date-of-birth-label {
    width: 18%;
    margin-left: 11px;
  }

  &__doc-type-input {
    width: 24%;
  }

  &__issue-date-label {
    width: 18%;
    margin-left: 11px;
  }

  &__issue-date-input {
    width: 24%;
  }

  &__card-number-input {
    width: 24%;
  }

  &__issue-by-label {
    width: 18%;
    margin-left: 11px;
  }

  &__issue-by-input {
    width: 24%;
  }

  &__subscriber-information-btn {
    border-radius: 17px;
  }

  &__approval-status-label {
    margin-bottom: 0;
  }

  &__add-complain-btn {
    border-radius: 17px;
  }

  &__complain-history-btn {
    border-radius: 17px;
  }

  &__service-table {
    background: white;
    border-radius: 12px;
    box-shadow: 0px 2.51907px 5.6679px rgb(0 0 0 / 25%);
    width: 100%;
    text-align: center;

    .--first-th {
      background: red;
      border-radius: 12px 0px 0px 0px;
    }

    .--last-th {
      background: red;
      border-radius: 0px 12px 0px 0px;
    }
  }

  &__menu-right-group {
    position: absolute;
    top: 140px;
    right: 20px;
  }
}

.mb-1 {
  margin-bottom: 0.5rem !important;
}

.buttonOK {
  width: 164.88px;
  height: 44.17px;
  left: 638px;
  top: 400px;
  background: #ed1f24;
  border-radius: 23.6547px;
  border-color: #ed1f24;
  color: white;
}

.redButton {
  background-color: #ed1f24 !important;
  border-color: #ed1f24 !important;
}

.packageText__Active {
  color: #ed1f24;
  font-weight: 500;
  cursor: pointer;
  text-decoration: underline;
}

.packageText__InActive {
  color: black;
  font-weight: 500;
  cursor: default;
}

@media only screen and (max-width: 992px) {
}

@media only screen and (max-width: 576px) {
  .--input {
    width: 100%;
  }

  p {
    width: 100%;
  }

  .subscriber-information {
    &__national-code-input {
      width: 18%;
      margin-right: 5px;
    }

    &__phone-input {
      width: 80%;
    }

    &__sim-commit-label {
      width: 100%;
    }

    &__sim-commit-input {
      width: 88%;
      margin-right: 5px;
    }

    &__sim-commit-month-input {
      width: 10%;
    }

    &__pack-commit-input {
      margin-bottom: 0.8rem;
    }

    &__time-commit-remain-label {
      width: 100%;
      margin-left: 0rem;
    }

    &__self-input {
      margin-bottom: 0.8rem;
    }

    &__date-of-birth-label {
      width: 100%;
      margin-left: 0px;
    }

    &__doc-type-input {
      margin-bottom: 0.8rem;
    }

    &__issue-date-label {
      margin-left: 0rem;
      width: 100%;
    }

    &__card-number-input {
      margin-bottom: 0.8rem;
    }

    &__issue-by-label {
      margin-left: 0rem;
      width: 100%;
    }
  }
}
</style>

<style scoped>
.custom-checkbox
.custom-control-input:disabled:checked
~ .custom-control-label::before {
  background-color: #ed1f24;
}
</style>
<style>
#modal-pdf .modal-content {
  height: 90vh;
}
</style>
